import { getStorageHealth } from "../app/storage";
import { getAnalyticsContext } from "../analytics/analyticsContext";
import { getMediaStorageCapabilities } from "../db/mediaRepo";
import type { AnalyticsPayload } from "../analytics/analyticsTypes";

export interface MediaSaveFailureDiagnosticsInput {
  compressedBytes?: number;
  thumbBytes?: number;
  width?: number;
  height?: number;
  mimeCategory?: string;
}

export async function collectMediaSaveFailureDiagnostics(
  input: MediaSaveFailureDiagnosticsInput
): Promise<AnalyticsPayload> {
  const context = getAnalyticsContext();
  const [storageHealthResult, capabilitiesResult] = await Promise.allSettled([
    getStorageHealth(),
    getMediaStorageCapabilities()
  ]);
  const storageHealth = storageHealthResult.status === "fulfilled" ? storageHealthResult.value : undefined;
  const capabilities = capabilitiesResult.status === "fulfilled" ? capabilitiesResult.value : undefined;

  return {
    ...input,
    browserFamily: context.browserFamily,
    platformFamily: context.platformFamily,
    displayMode: context.displayMode,
    storageUsage: storageHealth?.usage ?? capabilities?.storageEstimate?.usage,
    storageQuota: storageHealth?.quota ?? capabilities?.storageEstimate?.quota,
    storageUsageRatio: storageHealth?.usageRatio,
    storagePersisted: storageHealth?.persisted,
    storagePersistenceUnavailable: storageHealth?.persistenceUnavailable,
    mediaStorageFormat: capabilities?.preferredFormat,
    smallBlobProbeOk: capabilities?.smallBlob.ok,
    realisticBlobProbeOk: capabilities?.realisticBlob.ok,
    arrayBufferProbeOk: capabilities?.arrayBuffer.ok
  };
}
